const Stepper = ({ steps, currentStep, completedSteps }) => {
  return (
    <div className="w-full xs:my-4 sm:my-6">
      <div className="grid grid-cols-3 sm:flex items-center justify-between relative">
        {steps.map((step, index) => (
          <div
            key={index}
            className="flex-1 flex flex-col items-center relative text-center"
          >
            {/* Connector Line */}
            {index > 0 && (
              <div
                className={`absolute bottom-3 left-0 transform -translate-x-1/2 xs:w-[60%] sm:w-[75%] lg:w-[80%] h-[2px] z-0
                  ${
                    index === currentStep || completedSteps.includes(index)
                      ? "bg-goldMetallic"
                      : "bg-secondary"
                  }
                  ${index % 3 === 0 ? "hidden sm:block" : "block"}`}
              ></div>
            )}
            {/* Step Label */}
            <p
              className={`xs:text-xs sm:text-xs lg:text-base xl:text-lg mb-2
                ${
                  index === currentStep
                    ? "text-goldMetallic font-onestMedium"
                    : completedSteps.includes(index)
                    ? "text-goldMetallic font-onestMedium"
                    : "text-secondary font-onestRegular"
                }`}
            >
              {step}
            </p>
            {/* Step Circle */}
            <div
              className={`relative z-10 w-6 h-6 flex items-center justify-center rounded-full border-2 
                ${
                  index === currentStep || completedSteps.includes(index)
                    ? "border-goldMetallic"
                    : "border-secondary"
                }`}
            >
              <div
                className={`w-4 h-4 rounded-full 
                  ${
                    index === currentStep || completedSteps.includes(index)
                      ? "bg-goldMetallic"
                      : ""
                  }`}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
